// The unit vocabulary a BOM item's unit is picked from — the same list the API validates
// against (Units.cs); code, not data, so it ships with the app. An amount on a BOM
// relation is always expressed in the child's unit; nothing converts between units.
export interface Unit {
  code: string;
  label: string;
}

export const UNITS: Unit[] = [
  { code: 'szt', label: 'sztuka' },
  { code: 'kpl', label: 'komplet' },
  { code: 'kg', label: 'kilogram' },
  { code: 'g', label: 'gram' },
  { code: 'm', label: 'metr' },
  { code: 'cm', label: 'centymetr' },
  { code: 'mm', label: 'milimetr' },
  { code: 'in', label: 'cal' },
  { code: 'm2', label: 'metr kwadratowy' },
  { code: 'l', label: 'litr' },
];

export const UNIT_LABELS: Record<string, string> = Object.fromEntries(UNITS.map(unit => [unit.code, unit.label]));
